class Accordion extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        let links = document.querySelectorAll('.accordion-title');

        links.forEach(function(link) {
            link.addEventListener('click', function() {
                link.classList.toggle('active')
                link.closest('div').querySelector('ul').classList.toggle('hidden')
            })
        })
    }
}
customElements.define('accordion-block',  Accordion);